import normalize from './normalize';

const amount = (value) => {
  const numbers = normalize.number(value);
  return Number(numbers);
};

const cardNumber = (value) => {
  // Strips dashes from card number => 4556-8476-1290-6424 =>  4556847612906424
  // Strips whitespaces from card number => 4556 8476 1290 6424 =>  4556847612906424
  const stripped = value.replace(/-|\s/g, '');
  return stripped;
};

const ssn = (value) => {
  let strippedSsn = value;
  if (strippedSsn.charAt(6) === ' ' || strippedSsn.charAt(6) === '-') {
    strippedSsn = strippedSsn.slice(0, 6) + strippedSsn.slice(7, 11);
  }
  return strippedSsn;
};

const strip = {
  amount,
  cardNumber,
  ssn,
};

export default strip;
